import React, { useState } from "react";
import { Label, Input, Button } from "reactstrap";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import PhoneVerificationModal from "./PhoneVerificationModal";

const RegisterFormFields = ({
  name, setName,
  email, setEmail,
  datOffBirth, onDateOfBirthChange,
  dobChecked, setDobChecked,
  trainingChecked, setTrainingChecked,
  paypalName, setPaypalName,
  password, setPassword,
  veryPhoneNumber, setVeryPhoneNumber,
  gender, setGender,
  defaultGenderProps,
}) => {
  const [phoneTestModal, setPhoneTestModal] = useState(false);

  const handleNameCheck = (val) => {
    if (/[^a-z A-Z]/.test(val)) return;
    setName(val);
  };

  return (
    <>
      <Label className="mt-3 auth-label mb-0">Full Name</Label>
      <Input
        required
        placeholder="John Deo"
        type="text"
        className="custom-input"
        value={name}
        onChange={(e) => handleNameCheck(e.target.value)}
      />

      <Label className="mt-4 mt-sm-5 auth-label mb-0">Email</Label>
      <Input
        required
        placeholder="name@gmail.com"
        type="email"
        className="custom-input"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
      />

      <Label className="mt-4 mt-sm-5 auth-label mb-2">Date of Birth</Label>
      <Input
        type="date"
        name="date"
        value={datOffBirth}
        className="custom-input mb-2 pointer"
        onChange={(e) => onDateOfBirthChange(e.target.value)}
      />
      <div className="d-flex align-items-start mt-4">
        <input
          type="checkbox"
          id="dob-confirm"
          checked={dobChecked}
          onChange={(e) => setDobChecked(e.target.checked)}
          style={{ transform: "scale(1.55)" }}
          className="mt-4"
        />
        <Label htmlFor="dob-confirm" className="custom-checkbox-label text-dark mx-4 mt-3">
          I confirm that I am using this platform for lawful personal purposes,
          that I am not acting on behalf of any prohibited or sanctioned
          individual or organization, and that the information I provide is true
          and accurate.
        </Label>
      </div>

      <div className="d-flex align-items-start mt-4">
        <input
          type="checkbox"
          id="training-confirm"
          checked={trainingChecked}
          onChange={(e) => setTrainingChecked(e.target.checked)}
          style={{ transform: "scale(1.55)" }}
          className="mt-4"
        />
        <Label htmlFor="training-confirm" className="custom-checkbox-label text-dark mx-4 mt-3">
          I understand that LEARNING the 6 TRAINING VIDEOS of the Home Page
          helps me succeed at FHP.
        </Label>
      </div>

      <div className="mt-4">
        <Label className="mt-3 auth-label mb-0">PayPal Email</Label>
        <Input
          required
          placeholder="Your PayPal Account Email"
          type="email"
          className="custom-input mb-2"
          value={paypalName}
          onChange={(e) => setPaypalName(e.target.value)}
        />
        <small
          style={{
            display: "block",
            color: "#5e72e4",
            backgroundColor: "#f0f3ff",
            border: "1px solid #c5cff9",
            borderRadius: "6px",
            padding: "8px 10px",
            marginTop: "6px",
            lineHeight: "1.5",
          }}
        >
          <strong>ℹ️ PayPal is the only accepted payment method on this website.</strong>{" "}
          If you are entitled to a refund or receive a payment as a Fan Manager,
          it will be sent to your PayPal account using the email address provided here.
        </small>
      </div>

      <Label className="custom-label mt-2">
        If you don't have a PayPal account to send money, you can sign up{" "}
        <a href="https://www.paypal.com/in/webapps/mpp/account-selection" target="_blank" rel="noreferrer">
          <b>here</b>
        </a>
      </Label>

      {/* Phone */}
      {!veryPhoneNumber ? (
        <div className="mt-3">
          <Button color="primary" size="sm" onClick={() => setPhoneTestModal(true)}>
            Add Phone Number
          </Button>
        </div>
      ) : (
        <>
          <Label className="mt-4 auth-label mb-0">Phone Number</Label>
          <Input
            required
            type="tel"
            className="custom-input"
            value={veryPhoneNumber}
            readOnly
            placeholder="(xxx)-(xxx)-(xxxx)"
          />
        </>
      )}

      <Label className="mt-4 auth-label mb-0">Password</Label>
      <Input
        required
        placeholder="Your Password"
        type="password"
        className="custom-input"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
      />

      <Label className="auth-label mb-0 mt-3">Gender</Label>
      <Autocomplete
        {...defaultGenderProps}
        id="auto-complete-gender"
        autoComplete
        includeInputInList
        onChange={(e, val) => setGender(val)}
        renderInput={(params) => (
          <TextField {...params} placeholder="Gender" variant="standard" />
        )}
      />

      <PhoneVerificationModal
        isOpen={phoneTestModal}
        onVerified={(phone) => setVeryPhoneNumber(phone)}
        onClose={() => setPhoneTestModal(false)}
      />
    </>
  );
};

export default RegisterFormFields;
